import styled from 'styled-components'

export const InfoArea = styled.div`
  display: flex;
  position: relative;
  flex-direction: ${props => (props.isHorizontal ? 'row' : 'column')};
  flex-grow: 1;
  background: ${props => (props.background ? props.background : 'none')};
`
